import React from 'react';

import { Typography } from '@mui/material';

import type { PaymentMethodItemProps } from '../types';

type AchPaymentMethodItemProps = Pick<PaymentMethodItemProps, 'paymentMethod'>;

export const AchPaymentMethodItem: React.FC<AchPaymentMethodItemProps> = ({ paymentMethod }) => {
  return (
    <Typography variant="body2" color="text.secondary" fontWeight="bold">
      {paymentMethod.us_bank_account?.bank_name} **** {paymentMethod.us_bank_account?.last4}
    </Typography>
  );
};
